import clsx from "clsx";
import type { ButtonHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface DurationOptionCardProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "title"> {
    title: string;
    subtitle: string;
    containerClassName?: string;
    titleClassName?: string;
    subtitleClassName?: string;
}

export function DurationOptionCard({
    title,
    subtitle,
    className,
    containerClassName,
    titleClassName,
    subtitleClassName,
    type = "button",
    ...props
}: DurationOptionCardProps) {
    const buttonClassName = clsx({
        "flex w-full flex-col items-center justify-center gap-1 rounded-xl border-[1px] border-primary/15 px-3 py-2 text-center transition-colors select-none": true,
        "bg-dark hover:border-primary/40 hover:bg-primary/5": !props.disabled,
    });

    return (
        <button type={type} className={twMerge(buttonClassName, className, containerClassName)} {...props}>
            <span className={twMerge("text-[22px] leading-[0px] text-primary", titleClassName)}>{title}</span>
            <span className={twMerge("text-[16px] leading-[0px] text-dark", subtitleClassName)}>{subtitle}</span>
        </button>
    );
}
